import React, { createContext, useContext, useEffect, useState } from 'react';
import { API_BASE_URL } from "../config";

const CurrencyContext = createContext();

// Country code -> default currency mapping
// (agar backend GetPrice response me already country field hai to ye map hataakar
// direct match kar sakte ho — batao agar aisa hai to woh approach de dunga)
const COUNTRY_CURRENCY_MAP = {
  AU: 'AUD',
  NZ: 'NZD',
  US: 'USD',
  UK: 'GBP',
  GB: 'GBP',
};

export const CurrencyProvider = ({ children, user }) => {
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  // Currency list fetch karo (sirf ek baar)
  useEffect(() => {
    fetch(`${API_BASE_URL}/Price/GetPrice`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setCurrencies(data.data);
      })
      .catch(err => console.error('Failed to fetch currency:', err));
  }, []);

  // Default currency decide karo — user ka Country change ho ya list load ho, dono pe re-run ho
  useEffect(() => {
    if (currencies.length === 0) return;

    const userCountry = user?.Country || user?.country || null;
    const expectedCurrencyName = userCountry
      ? COUNTRY_CURRENCY_MAP[userCountry.toUpperCase()]
      : null;

    // Stored value ab country ke saath bind hai — agar wo isi user/country ke liye
    // save hua tha (jaise manually currency switch kiya tha), tabhi reuse hoga.
    let stored = null;
    try {
      stored = JSON.parse(localStorage.getItem('selectedCurrency'));
    } catch {}

    if (stored?.currency && stored?.country === userCountry) {
      const match = currencies.find(c => c.name === stored.currency.name);
      setSelectedCurrency(match || currencies[0]);
      return;
    }

    // Naya user / naya country -> uske country ki currency default karo
    const byCountry = expectedCurrencyName
      ? currencies.find(c => c.name === expectedCurrencyName)
      : null;
    const fallback = currencies.find(c => c.name === 'AUD') || currencies[0];
    const chosen = byCountry || fallback;

    setSelectedCurrency(chosen);
    localStorage.setItem(
      'selectedCurrency',
      JSON.stringify({ currency: chosen, country: userCountry })
    );
  }, [currencies, user]);

  const changeCurrency = (currencyName) => {
    const currency = currencies.find(c => c.name === currencyName);
    if (!currency) return;
    setSelectedCurrency(currency);
    const userCountry = user?.Country || user?.country || null;
    localStorage.setItem(
      'selectedCurrency',
      JSON.stringify({ currency, country: userCountry })
    );
  };

  return (
    <CurrencyContext.Provider value={{ currencies, selectedCurrency, changeCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);

// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { API_BASE_URL, Image_URL } from "../config";
// const CurrencyContext = createContext();

// export const CurrencyProvider = ({ children }) => {
//   const [currencies, setCurrencies] = useState([]);
//   const [selectedCurrency, setSelectedCurrency] = useState(null);

//   useEffect(() => {
//     fetch(`${API_BASE_URL}/Price/GetPrice`)
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setCurrencies(data.data);

//           const stored = localStorage.getItem('selectedCurrency');
//           const defaultCurrency = stored
//             ? JSON.parse(stored)
//             : data.data.find(c => c.name === 'AUD') || data.data[0];

//           setSelectedCurrency(defaultCurrency);
//         }
//       })
//       .catch(err => console.error('Failed to fetch currency:', err));
//   }, []);

//   const changeCurrency = (currencyName) => {
//     const currency = currencies.find(c => c.name === currencyName);
//     if (!currency) return;
//     setSelectedCurrency(currency);
//     localStorage.setItem('selectedCurrency', JSON.stringify(currency));
//   };

//   return (
//     <CurrencyContext.Provider value={{ currencies, selectedCurrency, changeCurrency }}>
//       {children}
//     </CurrencyContext.Provider>
//   );
// };

// export const useCurrency = () => useContext(CurrencyContext);
